<template>
<section class="assessmentSection page-systemReview">
    <div class="bg-white-cover"></div>
    <div class="pageContent">
        <div class="pageCompleted">System review | Frequently asked questions</div>
        <div class="pageTitle">Some quick tips before finishing up</div>
        <div class="pageText">Here are some things to think about before reviewing your system.</div>
    </div>
    <div class="advice">

        <!-- INLINE ADVICE -->
        <inline-advice :expand="false">
            <div slot="title">Scheduling your install</div>
            <div slot="text">
                <p>
                    All installs are scheduled over the phone. Your installation is done by a professional and will help you familiarize yourself with your system. Have any questions? Contact your dedicated support specialist
                </p>
            </div>
        </inline-advice>

        <!-- INLINE ADVICE -->
        <inline-advice :expand="false">
            <div slot="title">Reviewing your agreement</div>
            <div slot="text">
                <p>
                    During your installation call, we will review your contract with you. Monitoring contracts are sent digitally using a secure docusign. If you have any questions, give us a call at <b>{{ supportNumber }}</b>
                </p>
            </div>
        </inline-advice>
    </div>
    <continue-button to="/system-review" text="Next" />
</section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
    computed: {
        ...mapState(['uuid', 'supportNumber']),
        ...mapGetters(['selectedPlan'])
    },
    methods: {
        ...mapActions(['updateSystem'])
    },
    mounted() {
        this.updateSystem()
    }
}
</script>

<style lang="css"></style>
